import { render, staticRenderFns } from "./TwtiterCrisisMonitorFooter.vue?vue&type=template&id=41c698a8&scoped=true"
import script from "./TwtiterCrisisMonitorFooter.vue?vue&type=script&lang=ts"
export * from "./TwtiterCrisisMonitorFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c698a8",
  null
  
)

export default component.exports